import classNames from 'classnames';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  shouldScroll?: boolean;
}

export default function Breadcrumbs({ children, shouldScroll = false }: IProps) {
  const classes = classNames(
    'breadcrumbs',
    { 'breadcrumbs--scroll': shouldScroll },
  );

  return (
    <ul
      className={classes}
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      {
        React.Children.map(children, (child, idx) => {
          if (!child) return null;

          return (
            <li
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
              className="breadcrumbs__breadcrumb"
              key={idx}
            >
              {child}
            </li>
          );
        })
      }
    </ul>
  );
}
